import { withSvgIcon } from './withSvgIcon';

export const Info = withSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM10.9901 9.36366V17H13.0086V9.36366H10.9901ZM11.2188 8.04619C11.4376 8.24837 11.6994 8.34945 12.0044 8.34945C12.3126 8.34945 12.5744 8.24837 12.7899 8.04619C13.0086 7.84069 13.118 7.59377 13.118 7.30542C13.118 7.02038 13.0086 6.77677 12.7899 6.5746C12.5744 6.3691 12.3126 6.26636 12.0044 6.26636C11.6994 6.26636 11.4376 6.3691 11.2188 6.5746C11.0001 6.77677 10.8907 7.02038 10.8907 7.30542C10.8907 7.59377 11.0001 7.84069 11.2188 8.04619Z"
    fill="currentColor"
  />,
  { viewBox: '0 0 24 24' },
);
